/**
 * Protected route component - guards routes that require authentication
 */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getBillingState } from '../../services/billing/local-billing';

type ProtectedRouteProps = Readonly<{
  children: React.ReactNode;
  requireAuth?: boolean;
}>;

/**
 * Protected route wrapper
 * Redirects to login if not authenticated
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requireAuth = true 
}) => {
  const location = useLocation();
  const { subscribed, purchasedCourseIds } = getBillingState();
  const hasAnyPaidCourse = purchasedCourseIds.length > 0;
  
  // Redirect to login if auth required and user not authenticated
  if (requireAuth && !subscribed && !hasAnyPaidCourse) {
    return <Navigate to="/courses" state={{ from: location.pathname }} replace />;
  }
  
  return <>{children}</>;
};
